import {Test} from '../../../../types';
import {ListItem, CaptionText, Counter, CounterText, TestColorIndicator} from './index.styled';

interface Props {
	item: Test;
	allSubjectMode?: boolean
}

export function SelectableLisItemContent({item, allSubjectMode}: Props) {
	const hasResults = ({correct, incorrect, untested}: Omit<Test, 'id'>) =>
		correct + incorrect + untested !== 0;

	return (
		<ListItem>
			<TestColorIndicator testID={item.id}/>
			<CaptionText size='small'>{item.name} {allSubjectMode ? `(${item.subjectName})` : ''}</CaptionText>
			{hasResults(item)
				?
				<Counter>
					<CounterText size='small' font='mono' bold type='correct' zero={!item.correct}>{item.correct}</CounterText>
					<CounterText size='small' font='mono' bold type='incorrect' zero={!item.incorrect}>{item.incorrect}</CounterText>
					<CounterText size='small' font='mono' bold type='untested' zero={!item.untested}>{item.untested}</CounterText>
				</Counter>
				:
				<Counter>
					<CounterText size='small' font='mono'>No Results</CounterText>
				</Counter>
			}
		</ListItem>
	);
}
